'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colors = require('../base/colors.js');
var index = require('../utils/index.js');

/**
 * Background Colors with light-dark() function applied and detailed comments.
 */ const backgroundColor = {
    neutral: {
        DEFAULT: `light-dark(${colors.colors.black['25']}, ${colors.colors.black['600']})`,
        strong: `light-dark(${colors.colors.black['50']}, ${colors.colors.black['400']})`,
        subtle: {
            DEFAULT: `light-dark(${index.opacity(colors.colors.black['900'], 0)}, ${index.opacity(colors.colors.white, 0)})`,
            hovered: {
                DEFAULT: `light-dark(${index.opacity(colors.colors.black['900'], 5)}, ${index.opacity(colors.colors.white, 10)})`,
                invert: `light-dark(${index.opacity(colors.colors.white, 10)}, ${index.opacity(colors.colors.black['900'], 10)})`
            },
            clicked: `light-dark(${index.opacity(colors.colors.black['900'], 10)}, ${index.opacity(colors.colors.white, 15)})`
        },
        on: {
            surface: {
                background: `light-dark(${colors.colors.white}, ${colors.colors.black['700']})`
            }
        }
    },
    primary: {
        DEFAULT: `light-dark(${colors.colors.blue['50']}, ${colors.colors.blue['900']})`,
        strong: `light-dark(${colors.colors.blue['75']}, ${colors.colors.blue['800']})`,
        subtle: {
            DEFAULT: `light-dark(${index.opacity(colors.colors.blue['400'], 0)}, ${index.opacity(colors.colors.blue['400'], 0)})`,
            hovered: `light-dark(${index.opacity(colors.colors.blue['400'], 6)}, ${index.opacity(colors.colors.blue['400'], 20)})`,
            active: `light-dark(${index.opacity(colors.colors.blue['400'], 6)}, ${index.opacity(colors.colors.blue['400'], 20)})`,
            pressed: `light-dark(${index.opacity(colors.colors.blue['400'], 15)}, ${index.opacity(colors.colors.blue['400'], 40)})`
        }
    },
    surface: {
        primary: `light-dark(${colors.colors.white}, ${colors.colors.black['900']})`,
        background: `light-dark(${colors.colors.black['10']}, ${colors.colors.black['900']})`
    },
    error: `light-dark(${colors.colors.red['75']}, ${colors.colors.red['800']})`,
    severe: `light-dark(${colors.colors.mauve['75']}, ${colors.colors.mauve['800']})`,
    success: `light-dark(${colors.colors.green['75']}, ${colors.colors.green['800']})`,
    warning: `light-dark(${colors.colors.yellow['75']}, ${colors.colors.yellow['800']})`,
    info: `light-dark(${colors.colors.blue['75']}, ${colors.colors.blue['800']})`,
    processing: `light-dark(${colors.colors.violet['75']}, ${colors.colors.violet['800']})`,
    bold: {
        neutral: `light-dark(${colors.colors.black['700']}, ${colors.colors.white})`,
        interactive: {
            DEFAULT: `light-dark(${colors.colors.blue['600']}, ${colors.colors.blue['300']})`,
            bright: `light-dark(${colors.colors.blue['400']}, ${colors.colors.blue['300']})`,
            hovered: `light-dark(${colors.colors.blue['300']}, ${colors.colors.blue['400']})`
        },
        error: {
            DEFAULT: `light-dark(${colors.colors.red['600']}, ${colors.colors.red['400']})`,
            hovered: `light-dark(${colors.colors.red['500']}, ${colors.colors.red['500']})`
        },
        success: `light-dark(${colors.colors.green['600']}, ${colors.colors.green['300']})`
    },
    backdrop: `light-dark(${index.opacity(colors.colors.black['900'], 70)}, ${index.opacity(colors.colors.black['200'], 70)})`,
    code: {
        DEFAULT: `light-dark(${colors.colors.black['10']}, ${colors.colors.black['900']})`,
        line: {
            height: `light-dark(${colors.colors.transparent}, ${colors.colors.transparent})`
        }
    },
    accent: {
        green: `light-dark(${colors.colors.green['50']}, ${colors.colors.black['600']})`,
        blue: `light-dark(${colors.colors.blue['50']}, ${colors.colors.black['600']})`,
        purple: `light-dark(${colors.colors.purple['50']}, ${colors.colors.black['600']})`,
        violet: `light-dark(${colors.colors.violet['50']}, ${colors.colors.black['600']})`,
        pink: `light-dark(${colors.colors.red['50']}, ${colors.colors.black['600']})`,
        orange: `light-dark(${colors.colors.orange['50']}, ${colors.colors.black['600']})`
    }
};
/**
 * Gradient Background Color.
 */ const backgroundGradient = {
    'accent-blue-gradient': `linear-gradient(88.57deg, light-dark(${colors.colors.blue['90']}, ${colors.colors.blue['700']}) 0%, light-dark(${colors.colors.purple['75']}, ${colors.colors.purple['800']}) 94.58%)`,
    'accent-purple-gradient': `linear-gradient(88.57deg, light-dark(${colors.colors.purple['75']}, ${colors.colors.purple['800']}) 0%, light-dark(${colors.colors.blue['75']}, ${colors.colors.blue['800']}) 94.58%)`,
    'accent-green-gradient': `linear-gradient(115.93deg, light-dark(${colors.colors.teal['75']}, ${colors.colors.teal['800']}) 16.48%, light-dark(${colors.colors.orange['25']}, ${colors.colors.green['900']}) 80.74%)`,
    'accent-multi-gradient': 'radial-gradient(35.71% 35.71% at 100% 125.06%, #d42c3d33 0%, #d42c3d00 100%), radial-gradient(36.13% 27.47% at 78.02% 106.97%, #ba91fc38 0%, #ef8df800 100%), radial-gradient(37.47% 30.31% at 14.82% 108.89%, #7effba40 0%, #68d7fa00 100%), radial-gradient(44.02% 44.02% at 51.2% 123.38%, #514eff45 0%, #ad87ff00 100%)',
    'bold-accent-purple-gradient': `linear-gradient(68deg, light-dark(${colors.colors.blue['200']}, ${colors.colors.blue['500']}) 0%, light-dark(${colors.colors.purple['200']}, ${colors.colors.purple['400']}) 100%)`,
    'bold-green-gradient': 'linear-gradient(90deg, #007BB7 1.04%, #008390 98.61%)'
};
/**
 * Export as Tailwind Preset.
 */ const preset = {
    content: [],
    theme: {
        extend: {
            backgroundColor,
            backgroundImage: backgroundGradient
        }
    }
};

exports.backgroundColor = backgroundColor;
exports.backgroundGradient = backgroundGradient;
exports.default = preset;
//# sourceMappingURL=colors.bg.js.map
